import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../utils/api';

const statusBadge = (status) => <span className={`badge badge-${status}`}>{status}</span>;

export default function Sessions() {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    API.get('/sessions').then(res => setSessions(res.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="app-shell">
      <div className="topbar">
        <div className="topbar-title">Sessions</div>
        <button className="btn btn-primary btn-sm" style={{ width: 'auto', padding: '8px 16px', fontSize: 13 }} onClick={() => navigate('/sessions/create')}>
          + New
        </button>
      </div>
      <div className="page fade-in">
        {loading ? (
          <div className="loading">Loading sessions...</div>
        ) : sessions.length === 0 ? (
          <div className="empty-state">
            <h3>No sessions yet</h3>
            <p>Create your first game session to get started.</p>
            <button className="btn btn-primary" style={{ marginTop: 20, width: 'auto', padding: '12px 28px' }} onClick={() => navigate('/sessions/create')}>
              Create Session
            </button>
          </div>
        ) : (
          sessions.map(session => (
            <div key={session.id} className="card" style={{ cursor: 'pointer' }} onClick={() => navigate(`/sessions/${session.id}`)}>
              <div className="row-between" style={{ marginBottom: 8 }}>
                <div style={{ fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: 17 }}>{session.location_name}</div>
                {statusBadge(session.status)}
              </div>
              <div style={{ color: 'var(--text2)', fontSize: 13, display: 'flex', gap: 16 }}>
                <span>📅 {new Date(session.session_date).toLocaleDateString('en-PK', { weekday: 'short', month: 'short', day: 'numeric' })}</span>
                <span>👥 {session.player_count} players</span>
                {session.total_amount > 0 && <span>💰 Rs. {parseFloat(session.total_amount).toLocaleString()}</span>}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
